module.exports = __webpack_public_path__ + "img/home-banner3.398fa11c.jpg";